<template lang="pug">
.room-type-setting-tab(v-cloak)
  .mb-3
  .function.ml-2(v-if="_value != null")
    //- recruitmentRoom
    .content.d-flex.flex-row.align-items-center
      .function-name.flex-grow-1
        span 従来型多床室
      .d-flex.flex-row-reverse
        PermittedFunctionSwitch(v-model="_value.recruitmentRoom.multiBed")
    .mb-2
    .content.d-flex.flex-row.align-items-center
      .function-name.flex-grow-1
        span 従来型個室
      .d-flex.flex-row-reverse
        PermittedFunctionSwitch(v-model="_value.recruitmentRoom.conventinalSingle")
    .mb-2
    .content.d-flex.flex-row.align-items-center
      .function-name.flex-grow-1
        span ユニット型個室
      .d-flex.flex-row-reverse
        PermittedFunctionSwitch(v-model="_value.recruitmentRoom.unitTypeSingle")
    .mb-2
    .content.d-flex.flex-row.align-items-center
      .function-name.flex-grow-1
        span 個室
      .d-flex.flex-row-reverse
        PermittedFunctionSwitch(v-model="_value.recruitmentRoom.single")
    .mb-2
    .content.d-flex.flex-row.align-items-center
      .function-name.flex-grow-1
        span ２人部屋（夫婦部屋）
      .d-flex.flex-row-reverse
        PermittedFunctionSwitch(v-model="_value.recruitmentRoom.double")

    //- customRecruitmentRoom
    .mb-2(v-if="_value.customRecruitmentRoom && 0 < _value.customRecruitmentRoom.length")
    .contents(v-if="_value.customRecruitmentRoom && 0 < _value.customRecruitmentRoom.length" v-for="(room, index) in _value.customRecruitmentRoom")
      .content.d-flex.flex-row.align-items-center
        .function-name.flex-grow-1
          span {{ room.name }}
        .d-flex.flex-row-reverse
          PermittedFunctionSwitch(v-model="room.use")
      .mb-2(v-if="index != (_value.customRecruitmentRoom.length + 1)")

  .register-row(v-show="errorMessage")
    .register-group
      .register-value
        .error-message {{ errorMessage }}

  .mb-2
  .box-footer.register-footer
    .buttons.m-0
      button.btn.update-btn(@click="onUpdate" type="button") 変更
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import { FacilityGetModel } from "@/commons/services/Facilities";

import PermittedFunctionSwitch from "@/pc/basics/PermittedFunctionSwitch.vue";

/**
 * ### 部屋種類タブコンポーネント
 */
@Component({
  components: {
    PermittedFunctionSwitch
  }
})
export default class RoomTypeSettingTab extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  @Prop()
  value!: FacilityGetModel;
  @Prop()
  errorMessage!: string;

  get _value(): FacilityGetModel {
    return this.value;
  }

  set _value(newValue: FacilityGetModel) {
    this.$emit("input", newValue);
    return;
  }

  public onUpdate(): void {
    if (this.validRecruitmentRoom() == false && this.validCustomRequiredRecruitmentRoom() == false) {
      this.$emit("update:errorMessage", "部屋種類は1つ以上「使用する」にする必要があります");
      return;
    }

    this.$emit("update");

    return;
  }

  public validRecruitmentRoom(): boolean {
    if (
      (this.value.recruitmentRoom.multiBed ||
        this.value.recruitmentRoom.conventinalSingle ||
        this.value.recruitmentRoom.unitTypeSingle ||
        this.value.recruitmentRoom.double ||
        this.value.recruitmentRoom.single) == false
    ) {
      return false;
    } else {
      return true;
    }
  }

  public validCustomRequiredRecruitmentRoom(): boolean {
    for (const room of this.value.customRecruitmentRoom) {
      if (room.use == true) {
        return true;
      }
    }
    return false;
  }
}
</script>

<style lang="scss" scoped>
.room-type-setting-tab {
  .function {
    width: 420px;
  }

  .box-footer {
    padding: 10px 0 0 0 !important;

    .update-btn {
      width: 120px;
    }
  }
}
</style>
